import React from 'react'
import { Grid, Divider, Box, Typography } from '@mui/material'
import { Info } from '../components'
import { ActionButton } from '@emerald-works-nova/components'
import { useStyles } from '../style'
import Status from '../components/status'
import { format } from 'date-fns'
import { useSelector } from 'react-redux'
import { UserListSlice } from '../../../reducers'
import useSubscriptionForm from './useSubscriptionForm'
import SubscriptionInput from './subscription-input'
import SuspendDialog from './suspend-dialog'
import RestoreButton from './restore-button'

const formatDate = date => format(new Date(date), 'MMM d, y')

const SubscriptionTab = () => {
  const classes = useStyles()

  const [suspendDialogOpen, setSuspendDialogOpen] = React.useState(false)

  const {
    isEdit,
    handleEdit,
    handleCancelEdit,
    formState: { isDirty },
    loading,
    handleSubmit,
    onSubmit,
    control
  } = useSubscriptionForm()

  const { subscription } = useSelector(UserListSlice.selectors.selectUser)
  const { state, name, pausedAt, note } = subscription

  const suspensionDate = pausedAt ? formatDate(pausedAt) : null

  return (
    <Grid container direction='column' spacing={3} className={classes.tabPanel}>
      <Grid container item>
        <Info title='Subscription Name'>
          {isEdit ? <SubscriptionInput control={control} /> : name}
        </Info>
        <Info title='Subscription Status'>
          <Status status={state} />
        </Info>
      </Grid>
      <Grid container spacing={2} item xs={12}>
        {isEdit ? (
          <>
            <Grid item>
              <ActionButton
                onClick={handleCancelEdit}
                variant='secondary'
                dataTest='cancel-btn'
              >
                Cancel
              </ActionButton>
            </Grid>
            <Grid item>
              <ActionButton
                onClick={handleSubmit(onSubmit)}
                variant='primary'
                isWorking={loading}
                disabled={!isDirty}
                dataTest='save-changes-btn'
              >
                Save changes
              </ActionButton>
            </Grid>
          </>
        ) : (
          <Grid item>
            <ActionButton
              variant='secondary'
              onClick={handleEdit}
              dataTest='edit-subscription-button'
            >
              Edit subscription
            </ActionButton>
          </Grid>
        )}
      </Grid>
      {suspensionDate && (
        <>
          <Divider style={{ marginBlock: 8 }} />
          <Grid container item>
            <Info title='Suspension Date' data-test='suspension-date'>
              {suspensionDate}
            </Info>
            {note &&
              <Info
                title='Suspension Details'
                xs={8}
                data-test='suspension-details'
              >
                <Typography variant='inherit' color='textPrimary'>
                  {'Note: '}
                </Typography>
                {note.note}
                <br />
                <Typography variant='inherit' color='textPrimary'>
                  {'Date: '}
                </Typography>
                {formatDate(note.createdAt)}
              </Info>}
          </Grid>
        </>
      )}
      <Divider style={{ marginTop: 'auto', marginBottom: 8 }} />
      <Grid item xs={12}>
        {suspensionDate ? (
          <RestoreButton />
        ) : (
          <ActionButton
            variant='secondary'
            onClick={() => setSuspendDialogOpen(true)}
            dataTest='suspend-subscription-button'
          >
            <Box component='span' color='error.dark'>
              Suspend subscription
            </Box>
          </ActionButton>
        )}
        <SuspendDialog
          open={suspendDialogOpen}
          onClose={() => setSuspendDialogOpen(false)}
        />
      </Grid>
    </Grid>
  )
}

export default SubscriptionTab
